<template>
  <b-form class="assingment-form" @submit="event.preventDefault()">
    <b-form-group
      id="input-group-1"
      class="assingment-form__field"
      label="Quotations to be Assigned"
      label-for="input-1"
    >
      <b-form-input
        class="assingment-form__field--input"
        id="input-1"
        size="sm"
        v-model="form.quotes_per_user"
        type="number"
        placeholder="Number of quotations "
        required
        @input="updateQuotesPerUser"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      class="assingment-form__field"
      id="input-group-2"
      label="Status"
      label-for="input-2"
    >
      <b-form-checkbox
        class="assingment-form__field--input"
        v-model="form.is_active"
        id="input-2"
        switch
        size="lg"
        @change="updateAutoassigner"
      >
      </b-form-checkbox>
    </b-form-group>
  </b-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AssingmentForm",
  components: {},
  data() {
    return {
      activeSpinner: false,
      form: {
        quotes_per_user: 0,
        is_active: true
      },
      autoassignerInfo: null
    };
  },
  computed: {
    ...mapGetters("usersManagement/autoassigner", ["showAutoassignerData"])
  },
  watch: {
    showAutoassignerData() {
      this.fillAutoassignerInfo();
    }
  },
  created() {
    this.fillAutoassignerInfo();
  },
  methods: {
    async updateAutoassigner() {
      this.activeSpinner = true;
      if (
        this.form.quotes_per_user ||
        (this.form.quotes_per_user === 0 && !this.form.is_active)
      ) {
        this.form.is_active = !this.form.is_active;
        const data = {};
        data.body = { ...this.form };
        data.autoassignerId = this.autoassignerInfo.id;
        let response = await this.$store.dispatch(
          "usersManagement/autoassigner/updateAutoassigner",
          data
        );
        this.activeSpinner = false;
        if (response?.status === 204) {
          this.swal({
            title: "Good job!",
            text: "Auto-assign updated!",
            icon: "success",
            button: false,
            timer: 1000
          });
          await this.getAutoassignerInfo();
        }
      } else {
        this.swal({
          title: "Warning!",
          text: "The number of quotes is required.",
          icon: "warning",
          button: "OK"
        });
      }
      this.activeSpinner = false;
    },
    async updateQuotesPerUser() {
      if (this.showAutoassignerData[0].is_active && this.form.quotes_per_user) {
        const payload = {
          quotes_per_user: this.form.quotes_per_user,
          is_active: this.showAutoassignerData[0].is_active
        };
        const data = {};
        data.body = { ...payload };
        data.autoassignerId = this.autoassignerInfo.id;
        let response = await this.$store.dispatch(
          "usersManagement/autoassigner/updateAutoassigner",
          data
        );
        if (response?.status === 204) {
          this.swal({
            title: "Good job!",
            text: "Quotes per user updated!",
            icon: "success",
            button: false,
            timer: 1000
          });
          await this.getAutoassignerInfo();
        }
      }
    },
    async getAutoassignerInfo() {
      const params = {};
      params.skip = 0;
      params.limit = 100;
      await this.$store.dispatch(
        "usersManagement/autoassigner/getAutoassignerInfo",
        params
      );
    },
    fillAutoassignerInfo() {
      if (this.showAutoassignerData) {
        this.autoassignerInfo = this.showAutoassignerData[0];
        this.form.quotes_per_user = this.autoassignerInfo?.quotes_per_user;
        this.form.is_active = this.autoassignerInfo?.is_active;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.assingment-form {
  @include flex-wrap(flex-start);
  flex-direction: row;
  align-items: flex-start;
  width: 80%;
  margin: 1rem;
  &__field {
    // width: 45%;
    font-size: 12px;
    color: $color-gray-shadow;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin: 0 1rem;
    &--input {
      margin-left: 10px;
    }
  }
  &__submit-button {
    @include secondary-button;
    margin: 0;
  }
}

::v-deep .el-select .el-input__inner:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

@media (max-width: 900px) {
  .assingment-form {
    &__field {
      width: 45%;
    }
  }
}

@media (max-width: 650px) {
  .assingment-form {
    width: 100%;
    justify-content: center;
    align-items: center;
    &__field {
      width: 100%;
      justify-content: center;
      align-items: flex-start;
      margin: 1rem;
    }
  }
}

@media (max-width: 450px) {
  .assingment-form {
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    &__field {
      width: 100%;
      justify-content: center;
      flex-direction: column;
    }
  }
}
</style>
